// JS
import React, { setGlobal, useEffect, useState, lazy, Suspense } from 'reactn';
import { useMediaQuery } from 'react-responsive';
import smoothscroll from 'smoothscroll-polyfill';

// CUSTOM JS
import {
  randomString,
  nuqliumDataIndexSeven,
  poll,
  getInternationalPriceNuqlium
} from './components/shared/utils';
import {
  sendMonetateData,
  ometriaInit,
  gaDetailViewTracking,
  getSkuFromUrl,
  setUrl,
  getFormData
} from './components/shared/logic';
import UseFetchPost from './components/shared/useFetchPost';
import { productInfoPDP } from './components/shared/jsonData';

// COMPS
import Header from './components/Header';
//import Breadcrumb from './components/Breadcrumb';
import ProductDetails from './components/ProductDetails';
import ProductRecommendationsRecent from './components/ProductRecommendationsRecent';
import { LoadingSpinner } from './components/LoadingSpinner';
import ProductInformation from './components/ProductInformation';

import { showMonetateTests } from './components/shared/monetateTests';

// SCSS
import './styles/app.scss';

// COMPS - LAZY
const PhotoGalleryDesktopScroll = lazy(() =>
  import('./components/PhotoGalleryDesktopScroll')
);
const PhotoGalleryMobile = lazy(() =>
  import('./components/PhotoGalleryMobile')
);

smoothscroll.polyfill();
const internationalPrice = getInternationalPriceNuqlium();
const randomStringAll = randomString();
const devOrProd = process.env.REACT_APP_DEVORPROD;

// TOGGLE SCROLL LOCK - GLOBAL FUNCTION
window.scrollLock = () => {
  const scrollLock = document.querySelector('body');
  scrollLock.classList.toggle('scroll-lock');
};

// Set global monetate var
window.showMonetateTests = showMonetateTests;

// Set Global State
setGlobal(window.showMonetateTests);

const App = () => {
  const [componentData, setComponentData] = useState({});
  const [data, setData] = useState(null);
  const [prodCode, setProdcode] = useState(null);
  const [reset, setReset] = useState(null);
  const [, setLoadError] = useState(null);
  const [nqSupportApi, setSupportApi] = useState(false);
  const [nqPageData, setNqPageData] = useState(false);
  const [currency, setCurrency] = useState(null);
  const [gaAddToCartData, setGaAddToCartData] = useState(null);

  // USER SESSION
  const [userSession] = useState(window.location.search);

  // Product Groups / Swatches
  const [swatchesProdArray, setSwatchesProdArray] = useState(null);

  // DEVICES
  const isMobile = useMediaQuery({ maxWidth: 1023 });

  // CHANGE PROD STATE
  const [sku, setSku] = useState({
    DataIndex: nuqliumDataIndexSeven(),
    output: 'json',
    pagetype: 'product',
    pagekey: window.nqDataLayer?.pageKey
      ? window.nqDataLayer.pageKey
      : '4093772',
    //Prod Codes: 4062193, 4090464
    //Sale: 4070964
    //Out of stock: 4082263, 4066775
    //Model is wearing: 4066775
    //In Store Only: 4099594
    /*
    New Size Guide (TEST): 
      // TOPS
        Shirts: 4087850
        Overshirts: 4085154
        Gilets: 4069278
        Sweatshirts: 4093912
        Knitwear: 4083829
        Jackets: 4077789
        Lightweight: 4089270
        T-Shirts: 4066775, Long: 4099594
      // BOTTOMS
        Shorts: 4098757
        Sweatpants: 4060043
        Pants: 4092917
      // ACCESSORIES
        Bag: 4086701
        Wallets: 4045378
    */
    'settings[pricelist]': internationalPrice,
    'settings[mode]': 'web'
  });

  window.changeProd = (id) => {
    const Id = id.toString();
    const checkId = Id.length === 6 || Id.length === 7 ? Id : ''; // ID Length Check
    console.log('checkId:', checkId);
    var prodPrams = {
      DataIndex: nuqliumDataIndexSeven(),
      output: 'json',
      pagetype: 'product',
      pagekey: checkId,
      'settings[mode]': 'web'
    };
    console.log(prodPrams);

    setSku(prodPrams);

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  if (!nqSupportApi) {
    poll(
      () => {
        return typeof window.nq?.nqReactProduct === 'object';
      },
      1200, // Length of time to check - ms
      20 // Interval between checks - ms
    )
      .then(function () {
        // Polling done, now do something else
        setNqPageData(true);
      })
      .catch(function () {
        // Polling timed out, handle the error
        setNqPageData(false);
        setSupportApi(true);
      });
  }

  useEffect(() => {
    // Set product data from page if available
    if (nqPageData && !nqSupportApi) {
      // console.log('NQ Page Data: ', window.nq.nqReactProduct);
      setData(window.nq.nqReactProduct.products);
      setProdcode(window.nq.nqReactProduct.products[0].product.productid);
      setReset(null);
      sendMonetateData(
        window.nq.nqReactProduct.products[0].product.productid,
        window.nq.nqReactProduct.products[0].product.option.sku
      );
      setLoadError(false);
      setCurrency(window.chcurrency);

      // Set Swatches Data
      if (
        window.nq.nqReactProduct.products[0].product.productgroups.map(
          (prod) => prod.productid
        ) &&
        window.nq.nqReactProduct.products[0].product.productgroups.map(
          (prod) => prod.productid
        ).length > 0
      ) {
        setSwatchesProdArray(
          window.nq.nqReactProduct.products[0].product.productgroups.map(
            (prod) => prod.productid
          )
        );
      } else {
        // Empty swatchesProdArray state
        setSwatchesProdArray(null);
      }
    }

    if (nqSupportApi) {
      const apiQuery = {
        endPointUrl:
          'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
          devOrProd +
          '/index.php?v=' +
          randomStringAll,
        endPointPrams: getFormData(sku)
      };

      fetch(apiQuery.endPointUrl, {
        method: 'POST',
        body: apiQuery.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log('in fetch data', data);
          if (data?.data?.products?.products?.length > 0) {
            // console.log(data.data.products.products);
            setData(data.data.products.products);
            setProdcode(data.data.products.products[0].product.productid);
            setCurrency(data.data.pricelist.currency);
            setReset(null);
            /*
            sendMonetateData(
              data.data.products.products[0].product.productid,
              data.data.products.products[0].product.option.sku
            );
            */
            ometriaInit(data.data.products.products[0].product.productid);
            gaDetailViewTracking(data);
            setGaAddToCartData(data);
            setLoadError(false);

            // Check for Swatches Data
            if (
              data.data.products.products[0].product.productgroups.map(
                (prod) => prod.productid
              ) &&
              data.data.products.products[0].product.productgroups.map(
                (prod) => prod.productid
              ).length > 0
            ) {
              setSwatchesProdArray(
                data.data.products.products[0].product.productgroups.map(
                  (prod) => prod.productid
                )
              );
            } else {
              // Empty swatchesProdArray state
              setSwatchesProdArray(null);
            }
          } else {
            setLoadError(true);
          }
        });
    }
  }, [nqPageData, nqSupportApi, sku]);

  useEffect(() => {
    window.onpopstate = function (e) {
      if (
        data[0]?.product?.productid !== getSkuFromUrl(window.location.pathname)
      ) {
        window.changeProd(getSkuFromUrl(window.location.pathname));
      }
    };

    if (data && data[0]?.product) {
      if (
        data[0].product.productid !== getSkuFromUrl(window.location.pathname)
      ) {
        setUrl(data[0].product.url);
      }
    }
  }, [data]);

  /* GENREAL, SHIPPING & RETURNS PRODUCT INFORMATION FROM NQ */
  const getData = UseFetchPost(
    productInfoPDP.endPointUrl,
    productInfoPDP.endPointPrams
  );

  useEffect(() => {
    if (getData && getData.data) {
      let content = getData.data.content.content;
      let temporaryComponentData = {
        generalInformation: content[0].data,
        shippingInformation: content[1].data,
        returnsInformation: content[2].data,
        generalMessage: content[3].data
      };
      setComponentData(temporaryComponentData);
    }
  }, [getData]);
  /* GENREAL, SHIPPING & RETURNS PRODUCT INFORMATION FROM NQ */

  // console.log('swatchesProdArray:', swatchesProdArray);

  // Black Friday - 2024
  const bfExcludedCategories = [
    'WEB_BLK_FRI_EXC'
    /*'WEB_CP30', 'WEB_NIKE30'*/
  ];

  // APP 20 - 2025
  const appExcludedCategories = ['WEB_APP20_EXCLUDED'];

  return (
    <>
      {data && data[0]?.product && <Header data={data} />}
      <section className="flex flex-col lg:gap-y-32 font-sans text-base font-base tracking-widest">
        {data && data[0]?.product && (
          <>
            <section
              className={
                'container animate-fadeInHome p-0 md:pt-10 md:px-7 lg:px-8 xl:px-12'
              }
            >
              {/* 
                // Hiding new Bradcrumbs for now until Seven team have sorted product URL's / Categories
                <Breadcrumb data={data[0]} userSession={userSession} />
              */}
              <div id="pdpCtaBannerHook" />
              <div className="flex flex-col lg:flex-row gap-8 lg:gap-4 xl:gap-16">
                <div className="w-full lg:w-7/12">
                  {!isMobile ? (
                    <Suspense fallback={<LoadingSpinner />}>
                      <PhotoGalleryDesktopScroll
                        data={data[0]}
                        userSession={userSession}
                        text="Save"
                        blackFriday={false}
                        isSale={true}
                        freeDelBadge={true}
                        restockBadge={true}
                        bfExcludedCategories={bfExcludedCategories}
                      />
                    </Suspense>
                  ) : (
                    <Suspense fallback={<LoadingSpinner />}>
                      <PhotoGalleryMobile
                        data={data[0]}
                        isMobile={isMobile}
                        userSession={userSession}
                        text="Save"
                        blackFriday={false}
                        isSale={true}
                        freeDelBadge={true}
                        restockBadge={true}
                        bfExcludedCategories={bfExcludedCategories}
                      />
                    </Suspense>
                  )}
                </div>
                <div
                  className={`w-full lg:w-5/12 px-6 md:px-0 ${
                    !isMobile ? 'details-sticky' : ''
                  }`}
                >
                  <ProductDetails
                    data={data[0]}
                    dataPDPMessage={componentData.generalMessage}
                    setData={setData}
                    reset={reset}
                    setReset={setReset}
                    setSku={setSku}
                    isMobile={isMobile}
                    setSupportApi={setSupportApi}
                    currency={currency}
                    generalInformation={componentData.generalInformation}
                    shippingInformation={componentData.shippingInformation}
                    returnsInformation={componentData.returnsInformation}
                    userSession={userSession}
                    gaAddToCartData={gaAddToCartData}
                    blackFriday={false}
                    isSale={true}
                    swatchesProdArray={swatchesProdArray}
                    bfExcludedCategories={bfExcludedCategories}
                    appExcludedCategories={appExcludedCategories}
                  />
                </div>
              </div>
            </section>

            <section className="container animate-fadeInHome md:px-7 lg:px-8 xl:px-12">
              <ProductInformation
                data={data[0]}
                isMobile={isMobile}
                shippingInformation={componentData.shippingInformation}
                returnsInformation={componentData.returnsInformation}
              />
            </section>

            <section className="container animate-fadeInHome py-20 lg:pt-0 px-auto md:pr-0">
              {prodCode && (
                <ProductRecommendationsRecent
                  data={data[0]}
                  prodCode={prodCode}
                  userSession={userSession}
                  currency={currency}
                  useURLParameter={false}
                  blackFriday={false} // displays black friday feed "Black Friday Edit"
                  isSale={true} // displays Sale Recs
                />
              )}
            </section>
          </>
        )}
      </section>
    </>
  );
};

export default App;
